import dayjs, { Dayjs } from 'dayjs';
import weekday from 'dayjs/plugin/weekday';

dayjs.extend(weekday);

/**
 * Add hours, fractional part of daysToAdd
 * @param {Dayjs} date
 * @param {number} daysToAdd
 */
const addHoursToCurrentDate = (date: Dayjs, daysToAdd: number) => {
  const fractionalDay = daysToAdd % 1;
  const hoursToAdd = fractionalDay * 24;

  return date.add(hoursToAdd, 'hour');
}

/**
 * Add whole days
 * @param {Dayjs} date
 * @param {number} daysToAdd
 */
const addWorkDaysToCurrentDate = (date: Dayjs, daysToAdd: number) => {
  let wholeDays: number = Math.floor(daysToAdd);
  let addedDays: number = 0;
  while (addedDays < wholeDays) {
    date = date.add(1, 'day');
    if (!isWeekend(date)) {
      addedDays++;
    }
  }

  return date;
}

/**
 * Calculate due date. Add days to current date
 * @param {number} daysToAdd
 * @param {Dayjs} dateStart
 */
export const calculateDueDateByAddingDays = (daysToAdd: number, dateStart?: Dayjs) => {
  let date: Dayjs = dateStart ? dateStart : dayjs();
  // Shift date to first workday at 9 AM
  date = shiftDateToFirstWorkDayAt9AM(date);
  // Add workdays
  date = addWorkDaysToCurrentDate(date, daysToAdd);
  // Add hours
  date = addHoursToCurrentDate(date, daysToAdd);
  // Check again if time is shifted date to weekend
  date = shiftDateToFirstWorkDayAt9AM(date);
  // Return javascript Date object
  return date.toDate();
}

/**
 * Check if day is at weekend
 * @param {Dayjs} date
 */
const isWeekend = (date: Dayjs) => {
  const day = dayjs(date).day();
  return day === 0 || day === 6;
}

/**
 * Shift date to monday if current date is at weekend
 * @param {Dayjs} date
 */
const shiftDateToFirstWorkDayAt9AM = (date: Dayjs) => {
  if (isWeekend(date)) {
    const daysUntilMonday = (1 - date.day() + 7) % 7;
    date = date.add(daysUntilMonday, 'day');
    date = date.hour(9).minute(0).second(0); // Set time to 9 AM
  }

  return date
}